<template>
  <div>
    <button class="button taille topVert" @click="show = !show">
      <b-tag class="nb" type="is-dark" rounded v-if="$parent.filterProduit.length">
        {{$parent.filterProduit.length}}</b-tag>
      <b-icon :icon="show ? 'menu':'filter-variant'" v-else></b-icon>
      <span class="p_size16">Filtres</span>
    </button>
    <div class="notification is-white boxfiltre" v-if="show">
      <div class="content">
        <div v-if="nbreElement">
          <p class="has-text-weight-bold is-size-6">Propositions</p>
          <b-taglist>
            <b-tag rounded :type="isSelect(-1) ? 'is-info' : 'is-grey'" class="pointer">
              <p @click="filter(-1)"> Voir toutes les propsitions</p>
            </b-tag>
            <b-tag rounded :type="isSelect(0) ? 'is-info' : 'is-grey'" class="pointer"
              v-if="produits.panneauxLc.length">
              <p @click="filter(0)">Face(s) LC</p>
            </b-tag>
            <b-tag rounded :type="isSelect(1) ? 'is-info' : 'is-grey'" class="pointer"
              v-if="produits.reseauxTempo.length">
              <p @click="filter(1)">Réseau(x) temporaire(s)</p>
            </b-tag>
            <b-tag rounded :type="isSelect(2) ? 'is-info' : 'is-grey'" class="pointer"
              v-if="produits.reseauxLc.length">
              <p @click="filter(2)"> Réseau(x) LC</p>
            </b-tag>
            <b-tag rounded :type="isSelect(3) ? 'is-info' : 'is-grey'" class="pointer"
              v-if="produits.panneauxNumeriques.length">
              <p @click="filter(3)"> Face(s) numérique(s)</p>
            </b-tag>
            <b-tag rounded :type="isSelect(4) ? 'is-info' : 'is-grey'" class="pointer"
              v-if="produits.reseauxNumeriques.length">
              <p @click="filter(4)"> Réseau(x) numérique(s)</p>
            </b-tag>
            <b-tag rounded :type="isSelect(5) ? 'is-info' : 'is-grey'" class="pointer"
              v-if="produits.reseauxPersonnalise.length">
              <p @click="filter(5)">Réseau(x) personnalisé(s)</p>
            </b-tag>
          </b-taglist>
        </div>
        <div class="topVert">
          <p class="has-text-weight-bold is-size-6">Ma sélection</p>
          <b-tag rounded :type="select ? 'is-info' : 'is-grey'" class="pointer">
            <p @click="maSelection()">Voir ma sélection</p></b-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'filtreOpp',
  props: ['produits'],
  data() {
    return {
      show: false,
      nbrSelected: null,
      select: false,
    };
  },
  computed: {
    ...mapGetters({
      getMaSelection: 'getMaSelection',
    }),
    nbrSelection() {
      return {
      };
    },
    nbreElement() {
      const tableauProduits = (Object.values(this.produits)).flat();
      if (tableauProduits.length === 1) return false;
      return true;
    },
  },
  methods: {
    filter(value) {
      if (value === -1) {
        this.$parent.filterProduit = [];
        this.show = false;
        return '';
      }
      if (this.$parent.filterProduit.includes(value)) {
        const index = this.$parent.filterProduit.indexOf(value);
        this.$parent.filterProduit.splice(index, 1);
        this.show = false;
        return '';
      }
      if (!this.$parent.filterProduit.includes(value)) {
        this.$parent.filterProduit.push(value);
        this.show = false;
        return '';
      }
      return '';
    },
    isSelect(value) {
      if (value === -1) {
        return this.$parent.filterProduit.length === 0;
      }
      return this.$parent.filterProduit.includes(value);
    },
    ...mapActions(['selection']),
    maSelection() {
      this.selection(!this.getMaSelection);
      this.select = !this.select;
    },
  },
  mounted() {
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/composants/filtreOpp.vue